import React from 'react';
import './ThankYou.css';

const EmployeePacketThankYou: React.FC = () => {
  const handleHomeClick = () => {
    window.location.href = 'https://sdevelop.com/';
  };

  return (
    <div className="thank-you-container">
      <div className="thank-you-card">
        <div className="success-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <h1>Thank You!</h1>
        <h2>Your Employee Packet Has Been Submitted Successfully</h2>
        <p className="thank-you-message">
          We have successfully received your employee packet submission. 
          Your documents have been processed and are now with our HR team.
        </p>
        <div className="next-steps">
          <h3>What Happens Next?</h3>
          <ul>
            <li>Your employee packet and documents have been securely stored</li>
            <li>Our HR team will review your submission and contact you if any additional information is needed</li>
            <li>You will receive further instructions regarding your onboarding process via email</li>
          </ul>
        </div>
        <div className="contact-info">
          <p>
            If you have any questions about your submission, feel free to contact our HR department.
          </p>
        </div>
        <button 
          className="btn btn-primary home-button"
          onClick={handleHomeClick}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default EmployeePacketThankYou;
